module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAWlBMVEXeEB3////yoqfxmp/+9fXyn6T++Pj4zM7zp63wj5XiJzPfFyP/+/v97O385+n63d/1uLzypKnvipDqY2vmRlDkOUTgHir51df2wcXsd37scnroWWLnT1jjMj38yQ3mAAAAdklEQVQoz7XQyRHDIBAFURoQGO3W5j3/NO0E/rhKJfX13dodU4nF4gSTwQF4GD4Cs+bmDu1L+5YhLtrr4eer4T30H+1rB0OtfYlw27S/E+RG+9zCaPgT8E6XIWmtgCDVA/4UvQLVTr381WDrzhsumuqmrrij+wIgQgNQcromzQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/箭头@2x.png
// module id = K/yK
// module chunks = 0